module.exports = __webpack_public_path__ + "img/4.9689629d.svg";